export const constant = {
	selector: {
		aside: '.js-editor-aside-resizable',
		content: '.mainContainer',
		splitter: '.js-resizable-splitter',
		categoriesContainer: 'js-editor-categories',
	},
	storage: {
		editorMenuContentWidthRatio: 'initialEditorMenuContentWidthRatio',
	},
}
